import { ADD_TEMPLATE } from '../constants/template.constant';
import { ITemplate } from '../interfaces/template.interface';

export type TemplateAction = { type: string; payload: ITemplate };

export const addTemplate = (template: ITemplate): TemplateAction => ({
  type: ADD_TEMPLATE,
  payload: template,
});
